// TODO - Documentar
import { useEffect, useState } from 'react'
import * as con from "../../GlobalConstants"
import { Button, Checkbox, Radio, RadioGroup, Spinner } from '@blueprintjs/core'
import Search from '../search/Search'
import { formatDate, getToday } from '../../utils/dateFunctions'
import TransactionsUpload from './TransactionsUpload'
import TransactionsDelete from './TransactionsDelete'
import TransactionTableNavegation from './TransactionTableNavegation'
import { translateTransactions } from '../../utils/translateFunctions'
import { RefModelParameterHook } from '../hooks/ModelParameterHooks'
import TransactionsDownload from './TransactionsDownload'
import { EditTransactionsHook, StateTransactionsHook } from '../hooks/TransactionsHooks'


function TransactionsControl() {

    // Selected Transaction
    const [selectedTransactions, setSelectedTransactions] = StateTransactionsHook(con.SELECTED_TRANSACTIONS)

    // Client Type
    const clientType = RefModelParameterHook(con.CLIENT_TYPE)
    // Add new Row
    const setAddingNewRow = EditTransactionsHook(con.ADDING_NEW_ROW)
    
    const setFilterFun = EditTransactionsHook(con.FILTER_FUN_PARAMS)

    // Loading
    const setLoadingTransactions = EditTransactionsHook(con.LOADING_CURRENT_TRANSACTIONS)

    // States for the loader and the file upload modal
    const [isLoadingFile, setIsLoadingFile] = useState(false)
    const [showCompletionModal, setShowCompletionModal] = useState(false)
    const [loadedRecordsCount, setLoadedRecordsCount] = useState(0)

    // Filters
    const [includeActive, setIncludeActive] = StateTransactionsHook(con.INCLUDE_ACTIVE)
    const [includeExpired, setIncludeExpired] = StateTransactionsHook(con.INCLUDE_EXPIRED)
    const [includePrepay, setIncludePrepay] = StateTransactionsHook(con.INCLUDE_PREPAY)
    const [includePurchases, setIncludePurchases] = StateTransactionsHook(con.INCLUDE_PURCHASES)
    const [includeSales, setIncludeSales] = StateTransactionsHook(con.INCLUDE_SALES)

    // Disabled Filters
    const [canIncludeActive, setCanIncludeActive] = useState(() => true)
    const [canIncludeExpired, setCanIncludeExpired] = useState(() => true)
    const [canIncludePrepay, setCanIncludePrepay] = useState(() => true)
    const [canIncludePurchases, setCanIncludePurchases] = useState(() => true)
    const [canIncludeSales, setCanIncludeSales] = useState(() => true)
    const [canAddTransaction, setCanAddTransaction] = StateTransactionsHook(con.CAN_ADD_TRANSACTION)
    
    // Search
    const searchOptions = [{[con.ID] : con.COMMENT,
                            [con.TYPE] : con.TEXT,
                            [con.NAME] : "Comentario"
                          },
                          {[con.ID] : con.EXPIRATION_DATE,
                            [con.TYPE] : con.DATE,
                            [con.DEFAULT_VALUE] : formatDate(getToday()),
                            [con.NAME] : "Fecha de Vto."
                          },
                          {
                            [con.ID] : con.AMOUNT,
                            [con.TYPE] : con.MONEY,
                            [con.NAME] : "Monto",
                            [con.CURRENCY] : con.MONEY_USD
                          }]

    const handleFileUploadStart = () => {
        setIsLoadingFile(true)
    }

    const handleFileUploadComplete = (recordsCount = 0) => {
        setIsLoadingFile(false)
        setLoadedRecordsCount(recordsCount)
        setShowCompletionModal(true)
    }

    const handleCloseCompletionModal = () => {
        setShowCompletionModal(false)
        setLoadedRecordsCount(0)
    }

    useEffect(() => {

        if(selectedTransactions === con.EXPOSURES)
        {
            setCanIncludeActive(true)
            setCanIncludeExpired(true)
            setCanIncludePrepay(true)
            setCanIncludePurchases(false)
            setCanIncludeSales(false)
            setCanAddTransaction(true)

        }
        else if(selectedTransactions === con.COVERAGES_FWD)
        {
            setCanIncludeActive(true)
            setCanIncludeExpired(true)
            setCanIncludePrepay(false)
            setCanIncludePurchases(true)
            setCanIncludeSales(true)
            setCanAddTransaction(true)

        }
        else if(selectedTransactions === con.COVERAGES_SPOT)
        {
            setCanIncludeActive(false)
            setCanIncludeExpired(false)
            setCanIncludePrepay(false)
            setCanIncludePurchases(false)
            setCanIncludeSales(false)
            setCanAddTransaction(true)

        }
        else if(selectedTransactions === con.COVERAGES_OPTION)
        {
            setCanIncludeActive(true)
            setCanIncludeExpired(true)
            setCanIncludePrepay(false)
            setCanIncludePurchases(true)
            setCanIncludeSales(true)
            setCanAddTransaction(true)

        }
        else if(selectedTransactions === con.ACCOUNTS)
        {
            setCanIncludeActive(false)
            setCanIncludeExpired(false)
            setCanIncludePrepay(false)
            setCanIncludePurchases(false)
            setCanIncludeSales(false)
            setCanAddTransaction(false)
        }

        setLoadingTransactions(true)
        setTimeout(() => {              
            setLoadingTransactions(false)
        }, con.LOADING_TRANSACION_TIMEOUT);

    }, [selectedTransactions, setCanAddTransaction, setLoadingTransactions])

    useEffect(() => {
        setFilterFun({
            [con.INCLUDE_EXPIRED]: includeExpired,
            [con.INCLUDE_ACTIVE]: includeActive,
            [con.INCLUDE_PREPAY]: includePrepay,
            [con.INCLUDE_PURCHASES]: includePurchases,
            [con.INCLUDE_SALES]: includeSales
        })
                  
    }, [includeExpired, includeActive, includePrepay, includePurchases, includeSales, setFilterFun])

    return (
        <div>
            {isLoadingFile && (
                <div className="txn-file-upload-overlay-zx9k">
                    <div className="txn-file-upload-card-zx9k">
                        <Spinner size={60} />
                        <div className="txn-file-upload-title-zx9k">
                            Cargando transacciones desde archivo...
                        </div>
                        <div className="txn-file-upload-subtitle-zx9k">
                            Por favor espere mientras procesamos el archivo
                        </div>
                    </div>
                </div>
            )}

            {showCompletionModal && (
                <div className="txn-custom-modal-overlay-zx9k" onClick={handleCloseCompletionModal}>
                    <div className="txn-custom-modal-content-zx9k" onClick={(e) => e.stopPropagation()}>
                        <div className="txn-custom-modal-header-zx9k">
                            <div className="txn-custom-modal-header-icon-zx9k">✓</div>
                            <h3 className="txn-custom-modal-header-title-zx9k">Carga Completada</h3>
                        </div>
                        
                        <div className="txn-custom-modal-body-zx9k">
                            <div className="txn-completion-success-card-zx9k">
                                <div className="txn-completion-emoji-zx9k">✓</div>
                                <div className="txn-completion-main-text-zx9k">
                                    La carga de transacciones se ha completado exitosamente.
                                </div>
                                {loadedRecordsCount > 0 && (
                                    <div className="txn-completion-count-zx9k">
                                        Registros procesados: {loadedRecordsCount}
                                    </div>
                                )}
                            </div>
                            <div className="txn-completion-subtitle-zx9k">
                                Los datos han sido importados correctamente y ya están disponibles en el sistema.
                            </div>
                        </div>
                        
                        <div className="txn-custom-modal-footer-zx9k">
                            <button 
                                className="txn-custom-modal-close-button-zx9k"
                                onClick={handleCloseCompletionModal}
                            >
                                Aceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        
            <div className="bigParameterBoxTop compact">
                <div>
                    <div>
                        <h4>Flujo Actual</h4>
                        <div className="compact" style={{textAlign : "left"}}>             
                            <RadioGroup              
                                onChange={(e) => setSelectedTransactions(e.currentTarget.value)}
                                selectedValue={selectedTransactions}
                                inline={false}>
                                <Radio label={translateTransactions(con.EXPOSURES, clientType)} value={con.EXPOSURES} />
                                <Radio label={translateTransactions(con.COVERAGES_FWD, clientType)} value={con.COVERAGES_FWD} />
                                <Radio label={translateTransactions(con.COVERAGES_OPTION, clientType)} value={con.COVERAGES_OPTION} /> 
                                <Radio label={translateTransactions(con.COVERAGES_SPOT, clientType)} value={con.COVERAGES_SPOT} />
                                <Radio label={translateTransactions(con.ACCOUNTS, clientType)} value={con.ACCOUNTS} />
                            </RadioGroup>
                        </div>
                    </div>
                </div>
                <div>
                    <h4>Filtrar</h4>
                    <div className="columnParameterBoxLeft compact">            
                        <Checkbox checked={includeActive} label="Activas" onChange={() => setIncludeActive(!includeActive)} disabled={!canIncludeActive}/>
                        <Checkbox checked={includeExpired} label="Vencidas" onChange={() => setIncludeExpired(!includeExpired)} disabled={!canIncludeExpired}/>
                        <Checkbox checked={includePrepay} label="Prepagadas" onChange={() => setIncludePrepay(!includePrepay)} disabled={!canIncludePrepay}/>              
                        <Checkbox checked={includePurchases} label="Compras" onChange={() => setIncludePurchases(!includePurchases)} disabled={!canIncludePurchases}/>              
                        <Checkbox checked={includeSales} label="Ventas" onChange={() => setIncludeSales(!includeSales)} disabled={!canIncludeSales}/>              
                    </div>
                </div>
                <div>
                    <h4>Buscar</h4>
                    <div className="columnParameterBox">
                        <Search searchOptions={searchOptions}/>
                    </div>
                </div>
                <div>
                    <h4>Agregar</h4>
                    <div className="columnParameterBox">            
                        <TransactionsUpload 
                            onUploadStart={handleFileUploadStart}
                            onUploadComplete={handleFileUploadComplete}
                            disabled={isLoadingFile}
                        />
                        <div className="smallParameterBox">
                            <Button 
                                text="Agregar un Registro"  
                                icon="plus" 
                                onClick={(e) => setAddingNewRow(true)} 
                                disabled={!canAddTransaction || isLoadingFile}
                            />
                        </div>
                    </div>
                </div>            
                <div>
                    <h4>Eliminar</h4>    
                    <TransactionsDelete disabled={isLoadingFile} />
                </div>
                <div>
                    <h4>Descargar</h4>    
                    <TransactionsDownload disabled={isLoadingFile} />
                </div>
            </div>
            
            <div>
                <h3>{translateTransactions(selectedTransactions, clientType)}</h3>
                <TransactionTableNavegation />
            </div>
        </div>
    )
}

export default TransactionsControl